
export const FormFieldsConstants = {
	DIVIDER: 'divider',
	TITLE: 'title',
	SELECT: 'select',
	SELECT_MULTI: 'select_multi',
	SELECT_ACTIVE: 'select_active',
	SELECT_AVAILABLE_FOR: 'select_available_for',
	SELECT_LUNCH: 'select_lunch',
	TIME: 'time',
	TEXT: 'text',
	TEXT_AREA: 'text_area',
	TEXT_EMAIL: 'email',
	AUTOCOMPLETE: 'autocomplete',
	NUMBER: 'number',
	TIMESLOT: 'timeslot',
	EXPLANATION: 'explanation',
	IMAGE_PICKER: 'image_picker',
	ITEM_PICKER: 'item_picker',
	TIMESLOT_TIME_SELECT: 'timeslot_time_select',
	DATE_PICKER: 'date_picker',
	DATE_RANGED_PICKER: 'date_ranged_picker',
	ADDRESS: 'address',
}

export const FormStatus = {
	NONE: 'none',
	LOADING: 'loading',
	ERROR: 'error',
	SUCCESS: 'success',
}
